<template>
<section>Cleared</section>
</template>

<script>
  import {auth} from "@/firebase/init";
  export default {
    name: "clearData",
    created () {
      this.$cookie.delete('login-session');
      localStorage.removeItem("userDtls");
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminDtls');
      localStorage.removeItem('accounts');
      localStorage.removeItem('customers');
      if (auth) {
        auth.signOut()
      }
      window.location = '/'
    }
  }
</script>

<style scoped>

</style>
